<template>
  <div :class="computedClass">
    <q-table dense ref="table" bordered :columns="computedColumns" :data="computedData" :selection="selection" :selected="selected"  @row-contextmenu="openMenu"
      :pagination="computedPagination" :table-style="computedTableStyle" v-bind="$attrs" v-on="$listeners" :visible-columns="visibleColumnNames"
      separator="cell" flat :hide-bottom="hideBottom" binary-state-sort :row-key="computedRowKey" @row-click="onRowClick">
      <!-- <template v-slot:header-selection="scope">
        <q-toggle v-model="scope.selected" />
      </template> -->

      <!-- <template v-slot:body-selection="scope">
        <q-toggle v-model="scope.selected" />
      </template> -->
      <template v-if="!computedRownumberColumn.hidden" v-slot:[rownumberHeaderCellSlotName]="scope">
        <slot :name="rownumberHeaderCellSlotName" v-bind="scope">
          <th :class="scope.col.__tdClass+' i-table-header-cell__rownumber'" :style="scope.col.style">
            {{scope.col.label}}
          </th>
        </slot>
      </template>

      <template v-if="!computedRownumberColumn.hidden" v-slot:[rownumberBodyCellSlotName]="scope">
        <slot :name="rownumberBodyCellSlotName" v-bind="scope">
          <td :class="scope.col.__tdClass+' i-table-body-cell__rownumber'" :style="scope.col.style">
            <span></span>
          </td>
        </slot>
      </template>

      <template v-if="showTop" v-slot:top="scope">
        <slot name="top" v-bind="scope">
          <i-menu-avatar :icon="computedAvatarIcon" />
          <div class="text-h6 q-pa-lg text-primary">{{ computedTitle }}</div>
          <q-space />
        </slot>
      </template>

      <template v-slot:bottom="scope">
        <slot name="bottom" v-bind="scope">
          <div class="i-table-bottom">
            <q-btn dense flat color="primary" :label="$q.screen.lt.lg ? null : '选择列'" icon="rule" class="i-table-bottom-cols">
              <q-menu>
                <q-list>
                  <q-item v-for="col of computedColumns.filter(v => !v.fixed && v.field !== 'n')" :key="col.name">
                    <q-item-section>
                      <q-item-label>{{ col.label }}</q-item-label>
                    </q-item-section>
                    <q-item-section side>
                      <q-toggle :value="!col.hidden" @input="setColumnVisible(col.name, $event)" :disable="col.required" />
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
              <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                显示或隐藏表格中的列
              </q-tooltip>
            </q-btn>
            <q-input ref="txtGoToPage" borderless v-model="goToPage" hide-bottom-space prefix="跳转到" class="i-table-bottom-goto"
              input-style="text-align:center" mask="####" no-error-icon @keydown.enter="onGoToPageClick">
              <template v-slot:after>
                <i-btn round dense flat icon="reply" tooltip-text="跳转" tooltip-position="top" @click="onGoToPageClick" :glossy="false"/>
              </template>
            </q-input>
            <div class="i-table-bottom-pagination">
              <q-pagination :value="scope.pagination.page" @input="goTo" :max="scope.pagesNumber" direction-links boundary-links
                icon-first="skip_previous" icon-last="skip_next" icon-prev="fast_rewind" icon-next="fast_forward" :max-pages="5" boundary-numbers>
              </q-pagination>
            </div>
            <div class="i-table-bottom-notes">
              第{{scope.pagination.page}}页/共{{scope.pagesNumber}}页（共{{scope.pagination.rowsNumber}}行）
              <q-tooltip v-if="$q.screen.lt.lg">
                第{{scope.pagination.page}}页/共{{scope.pagesNumber}}页（共{{scope.pagination.rowsNumber}}行）
              </q-tooltip>
            </div>
            <q-select :value="scope.pagination.rowsPerPage" map-options @input="onRowsPerPageChange" :options="pageSizeOptions" borderless
              :display-value="`${$q.screen.lt.lg ? '' : '每页行数: '}${getRowsPerPageText(scope.pagination.rowsPerPage)}`">
              <q-tooltip v-if="$q.screen.lt.lg">
                每页行数{{getRowsPerPageText(scope.pagination.rowsPerPage)}}
              </q-tooltip>
            </q-select>
          </div>
        </slot>
      </template>

      <template v-for="(scopedSlot, slotName) of otherSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope" />
      </template>
    </q-table>
  </div>
</template>
<script>
import _ from 'lodash'
import { exportFile } from 'quasar'
import rules from '@/lib/rules.js'

function wrapCsvValue (val, formatFn, row) {
  let formatted = formatFn !== undefined
    ? formatFn(val, row)
    : ((typeof val === 'number' || typeof val === 'string') ? '\t' + val.toString() : val)

  formatted = formatted === undefined || formatted === null
    ? ''
    : String(formatted)

  formatted = formatted.split('"').join('""')
  /**
   * Excel accepts \n and \r in strings, but some other CSV parsers do not
   * Uncomment the next two lines to escape new lines
   */
  // .split('\n').join('\\n')
  // .split('\r').join('\\r')

  return `"${formatted}"`
}

const defaultRownumberOptions = {
  name: 'n',
  label: '序号',
  field: 'n',
  align: 'center',
  hidden: false
}

const pageSizeOptions = Object.freeze([{
  value: 5,
  label: '5'
}, {
  value: 10,
  label: '10'
}, {
  value: 15,
  label: '15'
}, {
  value: 20,
  label: '20'
}, {
  value: 50,
  label: '50'
}, {
  value: 100,
  label: '100'
}, {
  value: 99999999,
  label: '所有'
}])

export default {
  inheritAttrs: false, // class/style还是会被顶层div承接
  data () {
    return {
      customOptions: {
        columns: {}
      },
      pageSizeOptions,
      rules,
      goToPage: null
    }
  },
  props: {
    title: String,
    isClickTr: String,
    columns: Array,
    data: Array,
    rowKey: String,
    rownumber: Object,
    selection: {
      type: String,
      default: 'single'
    },
    selected: Array,
    pagination: {
      type: Object
    },
    hideBottom: Boolean,
    tableStyle: [String, Array, Object],
    avatar: Object,
    showTop: {
      type: Boolean,
      default: false
    },
    exportFileName: String,
    exportColumns: Array,
    exportFilterColumns: {
      type: Array,
      default () {
        return []
      }
    },
    wrapHeader: Boolean,
    layoutFixed: Boolean,
    showDefaultNumber: {
      type: Boolean,
      default: true
    },
    fixId: String
  },
  mounted () {
    this.$nextTick(() => {
      // this.initFixed()
    })
  },
  computed: {
    computedTableStyle () {
      const tablePagination = this.$refs.table?.computedPagination ?? this.computedPagination
      const rn = tablePagination.rowsPerPage * (tablePagination.page - 1)
      if (this.tableStyle && _.isString(this.tableStyle)) {
        return `${this.tableStyle};counter-reset:rownumber ${rn};`
      } else {
        const iTableStyle = { 'counter-reset': `rownumber ${rn}` }
        if (_.isArray(this.tableStyle)) {
          return [iTableStyle, ...this.tableStyle]
        } else if (this.tableStyle) {
          return [iTableStyle, this.tableStyle]
        } else {
          return iTableStyle
        }
      }
    },
    computedPagination () {
      return Object.assign(this.hideBottom ? {
        page: 1,
        rowsPerPage: 99999999
      } : {
        page: 1,
        rowsPerPage: 10
      }, this.pagination)
    },
    computedAvatarIcon () {
      return this.avatar?.icon
    },
    rownumberHeaderCellSlotName () {
      return `header-cell-${this.rownumberColumn.name}`
    },
    rownumberBodyCellSlotName () {
      return `body-cell-${this.rownumberColumn.name}`
    },
    viewRowsCount () {
      return Math.min(this.computedPagination.rowsPerPage ?? 0, this.computedData?.length ?? 0)
    },
    rownumberColumn () {
      defaultRownumberOptions.hidden = !this.showDefaultNumber
      return Object.assign({}, defaultRownumberOptions, {
        width: (10 + (this.viewRowsCount.toString().length * 10)) + 'px'
      }, this.rownumber ?? {})
    },
    computedClass () {
      return {
        'i-table': true,
        'i-table__rownumber': !this.computedRownumberColumn.hidden,
        'i-table__selection': ['single', 'multiple'].includes(this.selection), // none(默认) single multiple
        'i-table__layout-fixed': !!this.layoutFixed
      }
    },
    initialColumns () {
      return [this.rownumberColumn, ...(this.columns ?? [])]
    },
    initialColumnsMap () {
      return new Map(this.initialColumns.map(col => [col.name, col]))
    },
    computedRowKey () {
      return this.rowKey ?? 'id'
    },
    computedRownumberColumn () {
      return this.computedColumnsMap.get(this.rownumberColumn.name)
    },
    computedColumns () {
      const computedCols = []
      const table = document.getElementById(this.fixId)
      const colHtmlArr = document.getElementById(this.fixId)?.getElementsByClassName('q-table')[0]?.getElementsByTagName('th')
      for (let index = 0; index < colHtmlArr?.length; index++) {
        colHtmlArr[index].style.left = ''
      }
      for (const col of this.initialColumns) {
        let fixLeft = ''
        let fixHtml = null
        if (col.fixed && !col.hidden) {
          const index = this.initialColumns.findIndex(v => v.name === col.name)
          fixHtml = table?.getElementsByClassName('q-table')[0]?.getElementsByTagName('th')[index + 1]
          if (fixHtml) {
            fixLeft = fixHtml.offsetLeft + 'px'
            fixHtml.style.left = fixLeft
          }
        }
        if (fixHtml) {
          fixHtml.style.left = fixLeft
        }
        const customCol = this.customOptions.columns[col.name] ?? {}
        const computedCol = Object.assign({
          align: 'center',
          field: col.name,
          sortable: true
        }, col, customCol)
        computedCol.style = ''
        computedCol.headerStyle = ''
        if (this.wrapHeader) {
          computedCol.headerClasses = 'i-table__wrap-header' + (computedCol.headerClasses ? (' ' + computedCol.headerClasses) : '')
        }
        let style = ''
        let headerStyle = ''
        if ((computedCol.fixed) && !computedCol.hidden) {
          // const otherStyle = 'position: sticky'
          style += `position: sticky;left:${fixLeft};background-color: var(--i-color-theme-bg);z-index: 3 !important;border-right: 0 !important;box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);`
          headerStyle += `position: sticky;top:0;left:${fixLeft};background-color: var(--i-color-theme-bg);z-index: 4 !important;border-right: 0 !important;box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);`
        }
        if (computedCol.width) {
          const otherStyle = 'word-break:break-all;white-space:normal;overflow:hidden;text-align:center; padding: 0 5px;'
          headerStyle += `min-width:${computedCol.width};width:${computedCol.width};${otherStyle}`
          style += `width:${computedCol.width};${otherStyle}`
        }
        computedCol.style = style
        computedCol.headerStyle = headerStyle
        // if (col.fixed) {
        //   computedCol.headerClasses = 'fixed'
        //   // this.initFixed(index)
        // }
        computedCols.push(computedCol)
      }
      return computedCols
    },
    computedColumnsMap () {
      return new Map(this.computedColumns.map(col => [col.name, col]))
    },
    visibleColumns () {
      return this.computedColumns.filter(item => !item.hidden)
    },
    exportableColumns () {
      return this.exportColumns ?? this.visibleColumns.filter(item => {
        return item.name !== this.rownumberColumn.name && !this.exportFilterColumns.includes(item.name)
      })
    },
    visibleColumnNames () {
      return this.computedColumns.filter(item => !item.hidden).map(item => item.name)
    },
    computedData () {
      return this.computeData(this.data ?? [], this.computedRowKey)
    },
    computedTitle () {
      return this.title ?? this.$menuNode.text ?? '表格'
    },

    otherSlots () {
      const omitSlots = ['top', 'bottom']
      if (!this.computedRownumberColumn.hidden) {
        omitSlots.push(this.rownumberBodyCellSlotName)
        omitSlots.push(this.rownumberHeaderCellSlotName)
      }
      return _.omit(this.$scopedSlots, omitSlots)
    }
  },
  watch: {
    computedData () {
      if (this.selected?.length) {
        const selectedIds = new Set(this.selected?.map(item => item[this.computedRowKey]))
        const newSelectedData = this.computedData?.filter(item => selectedIds.has(item[this.computedRowKey]))
        this.$emit('update:selected', newSelectedData)
      }
    }
    // !!!!!!Quasar在初始化时通过 判断是否有row-click事件处理程序 来决定设置cursor 并 绑定原生事件，故通过$on动态注册的事件无效
    // selection: {
    //   immediate: true,
    //   handler (newVal, oldVal) {
    //     const newSelected = newVal === 'single' || newVal === 'multiple'
    //     const oldSelected = oldVal === 'single' || oldVal === 'multiple'
    //     if (newSelected !== oldSelected) {
    //       if (this.$refs.table) {
    //         this.$refs.table[newSelected ? '$on' : '$off']('row-click', this.onRowClick)
    //       } else {
    //         this.$nextTick(() => {
    //           this.$refs.table && this.$refs.table[newSelected ? '$on' : '$off']('row-click', this.onRowClick)
    //         })
    //       }
    //     }
    //   }
    // }
  },
  methods: {
    openMenu (e, row, index) {
      this.$emit('openMenu', { e, row, index })
    },
    computeData (data, rowKey) {
      const rows = data ?? []
      const firstRow = rows.length ? rows[0] : null
      if (firstRow && !(rowKey in firstRow)) {
        const newRows = new Array(rows.length)
        for (let index = 0; index < rows.length; index++) {
          newRows[index] = {
            [rowKey]: index + 1, // row-key默认值为id
            ...rows[index]
          }
        }
        return newRows
      }
      return rows
    },
    exportTable (data) {
      // naive encoding to csv format
      const title = '\uFEFF' + this.exportableColumns.map(col => wrapCsvValue(col.label))
      const computedData = data ? this.computeData(data) : this.computedData
      const content = [title].concat(
        computedData.map(row => this.exportableColumns.map(col => wrapCsvValue(
          typeof col.field === 'function'
            ? col.field(row)
            : row[col.field === undefined ? col.name : col.field],
          col.format, row
        )).join(','))
      ).join('\r\n')

      const status = exportFile(
        this.exportFileName ? `${this.exportFileName}.xls` : null || `${this.computedTitle}.xls`,
        content,
        {
          mimeType: 'text/xls',
          byteOrderMark: '\uFEFF', // 解决乱码问题
          encoding: 'utf-8'
        }
      )

      if (status !== true) {
        this.$q.notify({
          message: '浏览器已禁用文件下载',
          color: 'negative',
          icon: 'warning'
        })
      }
    },
    setColumnVisible (colName, visible) {
      if (visible === !(this.initialColumnsMap.get(colName)?.hidden)) {
        this.$delete(this.customOptions.columns, colName)
      } else {
        const customCol = this.customOptions.columns[colName]
        if (customCol) {
          this.$set(customCol, 'hidden', !visible)
        } else {
          this.$set(this.customOptions.columns, colName, ({ hidden: !visible }))
        }
      }
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    onRowClick (evt, row, index) {
      if (this.isClickTr) {
        return
      }
      if (Object.keys(row).includes('selected') && !row.selected) {
        return
      }
      this.$emit('clickData', row)
      if (this.selection === 'single') {
        if (this.$refs.table.isRowSelected(row[this.computedRowKey])) {
          return
        }
        this.$emit('update:selected', [row])
      } else if (this.selection === 'multiple') {
        let newSelected
        if (this.$refs.table.isRowSelected(row[this.computedRowKey])) {
          newSelected = this.selected?.filter(item => item !== row) ?? []
        } else {
          newSelected = this.selected ? [...this.selected, row] : [row]
        }
        this.$emit('update:selected', newSelected)
      }
    },
    scrollTo (index, edge) {
      this.$refs.table.scrollTo(index, edge)
    },
    sort (columnName) {
      this.$refs.table.sort(columnName)
    },
    onGoToPageClick () {
      if (!this.goToPage) {
        this.$refs.txtGoToPage && this.$refs.txtGoToPage.focus()
        return
      }
      if (this.goTo(this.goToPage)) {
        this.goToPage = null
      } else {
        this.$q.notify({
          message: `输入的页码超出范围：${this.goToPage}`,
          color: 'negative',
          icon: 'warning'
        })
        const txtGoToPage = this.$refs.txtGoToPage
        txtGoToPage.select()
        txtGoToPage.focus()
      }
    },
    goTo (page) {
      const pageInt = Number(page)
      const table = this.$refs.table
      if (Number.isInteger(pageInt) && pageInt >= 1 && pageInt <= table.pagesNumber) {
        this.setPagination({
          page: pageInt
        })
        return true
      }
      return false
    },
    setPagination (pagination) {
      const newPagination = {
        ...this.$refs.table.computedPagination,
        ...pagination
      }
      this.$refs.table.setPagination(newPagination)
    },
    onRowsPerPageChange () {
      if (arguments[0].value > 1000) {
        this.setPagination({ page: 1, rowsPerPage: arguments[0].value })
      } else {
        this.setPagination({ rowsPerPage: arguments[0].value })
      }
    },
    getRowsPerPageText (rowsPerPage) {
      return rowsPerPage < 1000 ? rowsPerPage : '所有'
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/quasar.variables.scss";

.i-table {
  .i-table-bottom {
    // font-size: 1vw !important;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    // > *,
    // .q-btn {
    //   font-size: 1vw !important;
    // }
  }
  .i-table-bottom-cols {
    flex-shrink: 1;
    white-space: nowrap;
  }
  .i-table-bottom-goto {
    white-space: nowrap;
    max-width: 8em;
    flex-shrink: 1;
    font-size: initial;
  }
  .i-table-bottom-pagination {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
  }
  .i-table-bottom-notes {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 1em;
    box-sizing: border-box;
    flex-shrink: 2;
  }
  position: absolute;
  box-sizing: border-box;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  .q-table__card {
    background-color: transparent !important;
    // box-shadow: 0 -5px 5px 1px rgba(0, 0, 0, 0.1);
  }
  .q-table__container {
    height: 100%;
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    // border-radius: 0.5em;
  }
  .q-table {
    tr th {
      font-weight: bold;
      position: sticky;
      /* higher than z-index for td below */
      z-index: 2;
      /* bg color is important; just specify one */
      background-color: var(--i-color-theme-bg);
    }
    /* this will be the loading indicator */
    thead tr:last-child th {
      /* height of all previous header rows */
      top: 48px;
      /* highest z-index */
      z-index: 3;
    }
    thead tr:first-child th {
      top: 0;
      z-index: 1;
      text-align: center;
      min-width: 55px;
    }
    tr:first-child th:first-child {
      /* highest z-index */
      z-index: 3;
    }

    td:first-child {
      z-index: 1;
    }

    td:first-child,
    th:first-child {
      position: sticky;
      left: 0;
    }
    th,
    td {
      padding: 0.1em;
      font-size: $body-font-size;
    }
    tbody tr:last-child td {
      border-bottom: solid 1px rgba(0, 0, 0, 0.12);
    }
    tr.selected {
      background-color: var(--i-color-action-selected);
    }
  }
  .q-table__bottom {
    font-size: $body-font-size;
  }
}
.i-table__layout-fixed {
  table {
    table-layout: fixed;
  }
}
.i-table__wrap-header {
  word-wrap:break-word  !important;
  white-space:pre-wrap !important;
  max-height:60px;
}
thead {
  tr {
    .fixed {
      position: sticky;
      background-color: var(--i-color-theme-bg);
      z-index: 3 !important;
      border-right: 0 !important;
      box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);
    }
  }
}
tbody {
  tr td{
    .fixed {
      position: sticky;
      background-color: var(--i-color-theme-bg);
      z-index: 3 !important;
      border-right: 0 !important;
      box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);
    }
  }
}
.i-table__rownumber {
  thead {
    tr {
      .i-table-header-cell__rownumber {
        position: sticky;
        background-color: var(--i-color-theme-bg);
        left: 55px;
        z-index: 3 !important;
        border-right: 0 !important;
        box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);
      }
    }
    tr.selected {
      .i-table-header-cell__rownumber{
        background-color: var(--i-color-action-selected);
      }
    }
  }
  tbody {
    tr {
      counter-increment: rownumber;
      .i-table-body-cell__rownumber {
        position: sticky;
        background-color: var(--i-color-theme-bg);
        left: 55px;
        z-index: 2;
        border-right: 0 !important;
        box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.2);
        *:first-child::before {
          content: counter(rownumber);
        }
      }
    }
    tr.selected {
      .i-table-body-cell__rownumber {
        background-color: var(--i-color-action-selected);
      }
    }
  }
}
.i-table__selection {
  th:first-child,
  td:first-child {
    width: 41px;
    position: sticky;
    /* higher than z-index for td below */
    z-index: 2;
    left: 55px;
    /* bg color is important; just specify one */
    background-color: var(--i-color-theme-bg);
  }
  tr.selected th:first-child,
  tr.selected td:first-child {
    background-color: var(--i-color-action-selected);
  }
}
.q-table--dense .q-table th:first-child, .q-table--dense .q-table td:first-child{
  text-align: center;
  padding: 0;
}
</style>
